import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';



export const INITIAL_STATE = Immutable({
    isLoading: false,
    status: false,
    error: null,

    isActivationInProgress: false,

    codeVerified: false,
    codeStatus: false
});



const resetAddChild = (state, action) => {
    return state.merge({
        isLoading: true,
        status: false,
        error: null
    });
};


const responseAddChild = (state, action) => {
    const res = action.response;

    if(res.ok) {
        return state.merge({
            isLoading: false,
            status: true,
            error: null
        });
    }

    else {
        return state.merge({
            isLoading: false,
            status: false,
            error: res.error || 'Failed to associate child'
        });
    }
};


const responseVerifyActivation = (state, action) => {
    const res = action.response;

    if(res.ok) {
        return state.merge({
            isLoading: false,
            status: true,
            error: null
        });
    }

    else {
        return state.merge({
            isLoading: false,
            status: false,
            error: res.error || 'Failed to associate child'
        });
    }
};

const resetVerifyCode = (state) => {
    return state.merge({
            isLoading: false,
            status: false,
            error: null
    });
};

const responseResetActivationCode = (state,action) => {
    return state.merge({
        isActivationInProgress: action.status
    });
};

const responseVerifyCode = (state, action) => {
    return state.merge({
        codeVerified: true,
        codeStatus: action.response.status
    });
};

const ACTION_HANDLERS = {
    [Types.ADD_CHILD_USING_ACTIVATION_CODE]: resetAddChild,
    [Types.RESPONSE_ADD_CHILD_USING_ACTIVATION_CODE]: responseAddChild,
    [Types.RESET_AVAILABILITY_CODE]: resetVerifyCode,
    [Types.RESPONSE_AVAILABILITY_CODE]: responseVerifyCode,
    [Types.RESPONSE_ADD_CHILD_USING_ACTIVATION_CODE_WITHOUT_DOB]: responseVerifyActivation,
    [Types.RESPONSE_RESET_ACTIVATION_CODE]: responseResetActivationCode

};



export default createReducer(INITIAL_STATE, ACTION_HANDLERS)